import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()(() => ({
  iframe: {
    width: 640
  }
}))

export default useStyles
